import {combineReducers} from 'redux';
import {auth} from './Auth'
import {theme} from "./Theme";

const rootReducer = combineReducers({
	auth,theme
});
export default rootReducer;
